import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SidebarTaskUi } from 'src/app/routes/routes-with-sidebar/shared/components/sidebar/model/sidebar.model';
import { CurrencyPipe } from '@angular/common';
import { TaskDateLabelComponent } from 'src/app/shared/components/task-date-label/task-date-label.component';

@Component({
  selector: 'ri-resolution-ui-mail-package-task-template',
  templateUrl: './mail-package-task-template.component.html',
  imports: [CurrencyPipe, TaskDateLabelComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MailPackageTaskTemplateComponent {
  readonly task = input.required<SidebarTaskUi>();
}
